export const RM01 = {
  columns: 12,
  rows: 2,
  visual: {
    id: 1,
    type: "advancedTable",
    colorTheme: "colorTheme1",
    title: "Coverage",
    binding: {
      data: {
        columns: [
          {
            name: "Code",
            columnName: "AgentCode",
            width: "120px",
            align: "left",
            sortable: true,
          },
          {
            name: "Name",
            columnName: "EmployeeName",
            width: "220px",
            align: "left",
            sortable: true,
          },
          {
            name: "Call Rate",
            columnName: "CallRate",
            width: "150px",
            align: "center",
            sortable: true,
            percent: true,
          },
          {
            name: "Call Reach",
            columnName: "CallReach",
            width: "150px",
            align: "center",
            sortable: true,
            percent: true,
          },
          {
            name: "Call Frequency",
            columnName: "CallFrequency",
            width: "170px",
            align: "center",
            sortable: true,
            percent: true,
          },
          {
            name: "Average Calls",
            columnName: "AvgCallsPerDay",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Regular Calls",
            columnName: "RegularCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Advanced Calls",
            columnName: "AdvancedCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Recovered Calls",
            columnName: "RecoveredCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Missed Calls",
            columnName: "MissedCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Incidental Calls",
            columnName: "IncidentalCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Pending Calls",
            columnName: "PendingCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
        ],
        title: "Region",
        endpoint: "RM01",
        parameters: [
          { key: "FromMonth", value: "CP1" },
          { key: "FromYear", value: "2026" },
          { key: "ToMonth", value: "CP1" },
          { key: "ToYear", value: "2026" },
          { key: "RegionCode", value: "" },
        ],
      },
      context: {
        point: {
          onClick: {
            selectedValueColumn: "AgentCode",
            visual: [
              {
                columns: 12,
                rows: 2,
                visual: {
                  id: 1,
                  type: "advancedTable",
                  colorTheme: "colorTheme1",
                  title: "Call Sessions",
                  binding: {
                    data: {
                      columns: [
                        {
                          name: "Session No.",
                          columnName: "SessionNumber",
                          width: "140px",
                          align: "left",
                          sortable: false,
                        },
                        {
                          name: "Code",
                          columnName: "AgentCode",
                          width: "140px",
                          align: "left",
                          sortable: true,
                        },
                        {
                          name: "Name",
                          columnName: "EmployeeName",
                          width: "220px",
                          align: "left",
                          sortable: true,
                        },
                        {
                          name: "Week",
                          columnName: "WEEK",
                          width: "100px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Session Date",
                          columnName: "SessionDate",
                          width: "150px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Call Type",
                          columnName: "CallType",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "New Institution Name",
                          columnName: "NewInstitutionName",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "New Institution Address",
                          columnName: "NewInstitutionAddress",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "New Customer Name",
                          columnName: "NewCustomerName",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Account Name",
                          columnName: "AccountName",
                          width: "370px",
                          align: "left",
                          sortable: true,
                        },
                        {
                          name: "Device ID",
                          columnName: "ActualDeviceID",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Actual Start",
                          columnName: "ActualStart",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Actual Location Lat",
                          columnName: "ActualLocationLat",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Actual Location Long",
                          columnName: "ActualLocationLong",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Actual Location Text",
                          columnName: "ActualLocationText",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Actual End",
                          columnName: "ActualEnd",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Actual End Location Lat",
                          columnName: "ActualEndLocationLat",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Actual End Location Long",
                          columnName: "ActualEndLocationLong",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Actual End Location Text",
                          columnName: "ActualEndLocationText",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Duration",
                          columnName: "Duration",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Reason Code",
                          columnName: "ReasonCode",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Reason Description",
                          columnName: "ReasonDescription",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                        {
                          name: "Remarks",
                          columnName: "Remarks",
                          width: "170px",
                          align: "center",
                          sortable: true,
                        },
                      ],
                      title: "Medical Representative",
                      endpoint: "RM01.1",
                      parameters: [
                        { key: "FromMonth", value: "CP1" },
                        { key: "FromYear", value: "2026" },
                        { key: "ToMonth", value: "CP1" },
                        { key: "ToYear", value: "2026" },
                        { key: "AgentCode", value: "" },
                      ],
                    },
                    context: {
                      point: {
                        onClick: {},
                      },
                    },
                  },
                },
              },
            ],
          },
        },
      },
    },
  },
};
